/**
 * Product tile colour swatches.
 *
 * The swatch buttons are rendered as siblings of the product link, never inside
 * it: a <button> nested in an <a> is invalid HTML and makes the browser eat the
 * first click on the card. This script gives those buttons their behaviour -
 * picking a colour swaps the tile image and repoints the link at that variant.
 */
(function () {
  'use strict';

  var TILE = '.product-tile';
  var SWATCH = '.product-tile__swatch';

  function swapImage(tile, src) {
    var image = tile.querySelector('.product-tile__image--primary');
    if (!image || !src) return;

    if (!image.hasAttribute('data-original-src')) {
      image.setAttribute('data-original-src', image.currentSrc || image.src);
    }

    // A fixed src only wins once the responsive srcset is out of the way.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
  }

  function select(swatch) {
    var tile = swatch.closest(TILE);
    if (!tile) return;

    var swatches = tile.querySelectorAll(SWATCH);
    for (var i = 0; i < swatches.length; i++) {
      var isCurrent = swatches[i] === swatch;
      swatches[i].classList.toggle('is-selected', isCurrent);
      swatches[i].setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
    }

    tile.classList.add('is-swatch-selected');
    swapImage(tile, swatch.getAttribute('data-variant-image'));

    var url = swatch.getAttribute('data-variant-url');
    if (!url) return;

    var link = tile.querySelector('.product-tile__link');
    if (link) link.setAttribute('href', url);

    var quickShop = tile.querySelector('.product-tile__quick-shop');
    if (quickShop) quickShop.setAttribute('data-quick-shop', url);
  }

  // Delegated so tiles added later (pagination, filtering) work without rebinding.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var swatch = target.closest(SWATCH);
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      select(swatch);
      return;
    }

    var quickShop = target.closest('.product-tile__quick-shop');
    if (quickShop && quickShop.getAttribute('data-quick-shop')) {
      event.preventDefault();
      window.location.href = quickShop.getAttribute('data-quick-shop');
    }
  });
})();
